var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyTypeCrossovers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 13h-.05l-3.3-.75v-3.3c.05-.1 1-2.3 2.95-2.65 1.7-.3 5-.95 5.35-1l8.8-3.9h12.6l.05.05c.1.1 2.85 1.95 3.35 5.9l1.15 1.5v2c-.05.05-.7 1.7-3.35 1.7-.15 0-.25-.1-.25-.25s.1-.25.25-.25c2.15 0 2.8-1.1 2.9-1.35V9l-1.1-1.5v-.05C35.35 4 33.1 2.2 32.7 1.9H20.3l-8.75 3.9c-.05 0-3.6.75-5.4 1.05-1.5.25-2.4 2-2.55 2.3v2.75l2.9.65c.15.05.2.15.2.3-.1.1-.2.15-.3.15z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 13h-12.65c-.15 0-.25-.1-.25-.25s.1-.25.25-.25h12.65c.15 0 .25.1.25.25s-.15.25-.25.25z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.201 14.65c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9zm0-5.25a2.4 2.4 0 00-2.4 2.4c0 1.35 1.05 2.4 2.4 2.4 1.35 0 2.4-1.05 2.4-2.4 0-1.35-1.05-2.4-2.4-2.4zM10.3 14.65c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9zm0-5.25a2.4 2.4 0 00-2.4 2.4c0 1.35 1.05 2.4 2.4 2.4 1.35 0 2.4-1.05 2.4-2.4 0-1.35-1.05-2.4-2.4-2.4z",
    fill: "#10B1D7"
  })));
}
export default SvgBodyTypeCrossovers;